<template>
    <div class="inline-block">
        <el-row class="action-row">
            <!-- Add New -->
            <el-tooltip class="item" effect="dark" :content="$t('button.AddNew')" placement="top">
                <el-button v-if="isAddPermission && isAdd" size="mini" class="add-new-action" type="primary" icon="el-icon-plus" circle @click="emitAction('addNew')" />
            </el-tooltip>

            <!-- Add Multiple New -->
            <el-tooltip class="item" effect="dark" :content="$t('button.AddMultiNew')" placement="top">
                <el-button v-if="isAddMultiPermission && isAddMulti" size="mini" class="add-new-action" type="muted" icon="el-icon-document-add" circle @click="emitAction('addMultipleNew')" />
            </el-tooltip>

            <!-- Refresh Table -->
            <el-tooltip class="item" effect="dark" :content="$t('button.Refresh')" placement="top">
                <el-button size="mini" type="success" icon="el-icon-refresh-right" circle @click="emitAction('refreshTable')" />
            </el-tooltip>

            <!-- Batch Delete -->
            <div v-if="isDeletePermission && isBatchDelete" class="batch-delete-btn">
                <el-tooltip class="item" effect="dark" :content="$t('button.BatchDelete')" placement="top">
                    <el-popconfirm
                        :title="$t('button.AreYouSureToDeleteThis')"
                        :confirm-button-text="$t('button.Confirm')"
                        :cancel-button-text="$t('button.Cancel')"
                        @confirm="emitAction('batchDelete')"
                    >
                        <el-button slot="reference" size="mini" type="warning" icon="el-icon-delete" circle />
                    </el-popconfirm>
                </el-tooltip>
            </div>

            <!-- Export -->
            <!-- <el-tooltip class="item" effect="dark" :content="$t('button.Export')"  placement="top">
                <el-button v-if="isExportPermission && isExport" size="mini" type="info" icon="el-icon-download" circle @click="emitAction('exportData')"></el-button>
            </el-tooltip> -->

            <!-- Print QR Code -->
            <el-tooltip class="item" effect="dark" content="Print QR" placement="top">
                <el-button v-if="isPrintQr" size="mini" type="info" icon="el-icon-printer" circle @click="emitAction('printQRCode')" />
            </el-tooltip>

            <!-- More -->
            <el-tooltip class="item" effect="dark" :content="$t('button.Filter')" placement="top">
                <el-button v-if="isFilter" size="mini" type="danger" icon="el-icon-s-operation" circle @click="emitAction('filterData')" />
            </el-tooltip>
        </el-row>
    </div>
</template>

<script>
export default {
    name: "ActionButton",
    props: {
        isAdd: {
            type: Boolean,
            default: true,
        },
        isAddMulti: {
            type: Boolean,
            default: true,
        },
        isAddPermission: {
            type: Boolean,
            default: true,
        },
        isAddMultiPermission: {
            type: Boolean,
            default: false,
        },
        isDeletePermission: {
            type: Boolean,
            default: true
        },
        isBatchDelete: {
            type: Boolean,
            default: true
        },
        isExportPermission: {
            type: Boolean,
            default: true
        },
        isExport: {
            type: Boolean,
            default: true
        },
        isFilter: {
            type: Boolean,
            default: true
        },
        isPrintQr: {
            type: Boolean,
            default: true
        },
    },
    methods: {
        emitAction(actionName) {
            this.$emit(actionName);
        }
    }
};
</script>

<style lang="css" scoped>
.action-row{
    display: flex;
    justify-content: flex-end;
}
.batch-delete-btn{
    margin: 0 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/Button/TableActionButton.vue